import React, { useState } from 'react';
import Container from '../ui/Container';
import SectionTitle from '../ui/SectionTitle';
import ProjectFilter from './ProjectFilter';
import ProjectsGrid from './ProjectsGrid';

const Portfolio = () => {
  const categories = ['Tutti', 'WordPress'];
  const [activeCategory, setActiveCategory] = useState('Tutti');

  const projects = [
    {
      title: "\"Da arturo\" Gastronomia",
      description: "Sito vetrina per un alimentari locale, con presentazione dei prodotti e dei servizi offerti.",
      image: `${process.env.PUBLIC_URL}/arturo.jpg`,
      tags: ['WordPress'],
      liveUrl: "https://daarturo.it/"
    },
    {
      title: "Studio Dentistico Del Tedesco Piovan",
      description: "Sito vetrina per studio dentistico, con informazioni su servizi odontoiatrici e contatti.",
      image: `${process.env.PUBLIC_URL}/dentista.jpg`,
      tags: ['WordPress'],
      liveUrl: "https://studiodeltedescopiovan.it/"
    }/*,
    {
      title: "Girardello Services",
      description: "Sito vetrina per azienda di servizi, con presentazione delle attività svolte e possibilità di contatto diretto.",
      image: `${process.env.PUBLIC_URL}/girardello.jpg`,
      tags: ['WordPress'],
      liveUrl: "https://girardelloservices.com/"
    }*/
  ];

  const filteredProjects = activeCategory === 'Tutti'
    ? projects
    : projects.filter(project => project.tags.includes(activeCategory));

  return (
    <section id="portfolio" className="py-20 bg-gray-50">
      <Container>
        <SectionTitle>I Miei Progetti</SectionTitle>
        <ProjectFilter 
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />
        <ProjectsGrid projects={filteredProjects} />
      </Container>
    </section>
  );
};

export default Portfolio;